export type LoginStep = 'username-and-password' | 'level-2-recognition' | 'otp';
export const LoginStep = {
  UsernameAndPassword: 'username-and-password' as LoginStep,
  Level2Recognition: 'level-2-recognition' as LoginStep,
  Otp: 'otp' as LoginStep,
};

export type OtpDeliveryMethod = 'SMS' | 'APP' | 'EMAIL';
export const OtpDeliveryMethod = {
  APP: 'APP' as OtpDeliveryMethod,
  SMS: 'SMS' as OtpDeliveryMethod,
  EMAIL: 'EMAIL' as OtpDeliveryMethod,
};

export interface AuthenticationPayload {
  username: string;
  password: string;
  otp?: string;
  otp_delivery_method?: OtpDeliveryMethod;
}
